import { UserAttributesTable } from "../../../../components/User/AttributesTable";
import React from "react";
import { CircularProgress, TableCell, TableRow } from "@mui/material";
import { Await, useLoaderData } from "react-router-dom";
import { CustomClaims } from "../../../../models/ProjectUser";

export const CustomClaimsTable = () => {
  const data = useLoaderData() as any

  return <React.Suspense fallback={<CircularProgress />}>
    <Await resolve={data.customClaims} errorElement={<></>}>
      {(customClaims: Awaited<CustomClaims | null>) => (
        <UserAttributesTable head={<CustomClaimsTableHead />} emptyContent="No custom claims set." label="Custom claims"
                             rows={customClaims !== undefined && customClaims !== null && Object.keys(customClaims).length > 0 ?
                               Object.entries(customClaims).map(([name, value]) => <Row key={name} name={name} value={value} />) : undefined} />
      )}
    </Await>
  </React.Suspense>
}

const CustomClaimsTableHead = () => {
  return <>
    <TableCell>Claim</TableCell>
    <TableCell>Value</TableCell>
  </>
}

const formatValue = (value: string | number | boolean | string[]): string => {
  if (Array.isArray(value)) {
    return value.join(", ")
  }
  return String(value)
}

const Row = (props: { name: string, value: string | number | boolean | string[] }) => {
  const { name, value } = props

  return <TableRow sx={{ height: '53px' }}>
    <TableCell>{name}</TableCell>
    <TableCell>{formatValue(value)}</TableCell>
  </TableRow>
}
